/*!
 * @copyright	Copyright (C) 2016 Piotr Konieczny. All rights reserved.
 * @license		GNU General Public License version 2 or later; see LICENSE.txt
 */

/**
 * Slideshow handler
 */
window.WgTemplate.PkgSlideshowkit = (function() {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    function PkgSlideshowkit(element, options) {

        this.name = 'PkgSlideshowkit';

        /** @type {jQuery} */
        this.$element = jQuery(element);

        /** @type {Object} */
        this.options = (options || {});

        /** @type {Object} */
        this.extensionSettings = this.$element.data('wgPkgSlideshowkit');

        // Attach events and save in cookie
        this.$element.on('show.uk.slideshow', jQuery.proxy(this.onSlide, this));

        // Reinit slide animation after manunal change
        this.$element.on('click', '[data-uk-slideshow-item]', jQuery.proxy(this.onSlidenavClick, this));
    }

    /**
     * Create new instance for jQuery.each
     *
     * @param {integer} index
     * @param {HTMLElement} element
     *
     * @return {PkgSlideshowkit}
     *
     * @this {WgTemplate}
     */
    PkgSlideshowkit.getInstance = function(index, element) {

        this.registerExtension(new PkgSlideshowkit(element, this.options));
    };

    /**
     * Auto slided or user pressed next/ prev
     *
     * @param {jQuery.Event} event
     * @param {jQuery} $current
     * @param {jQuery} $previous
     * @param {function} UIkitSlideshow
     */
    PkgSlideshowkit.prototype.onSlide = function(event, $current, $previous, UIkitSlideshow) {

        var $slideshow =  jQuery(event.target);
        var index = $current.data('wgPkgSlideshowIndex');

        var cookieName = 'pkg_slideshowkit';
        var cookieData = this.getCookie(cookieName);

        cookieData[this.extensionSettings.id] = index;

        this.setCookie(cookieName, cookieData);
    };

    /**
     * Slide navigation button clicked
     *
     * @param {jQuery.Event} event
     *
     * @see https://github.com/uikit/uikit/issues/1290
     */
    PkgSlideshowkit.prototype.onSlidenavClick = function(event) {

        // Listen once to slide animation end
        this.$element.one('show.uk.slideshow', function(event, next, current, uikitSlideshow) {
            // Delay start by additional interval
            window.setTimeout(function() {
                uikitSlideshow.start();
            }, uikitSlideshow.option('autoplayInterval'));
        });
    };

    /**
     * Load cookie as JSON
     *
     * @param {string} key
     *
     * @return {Object}
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
     */
    PkgSlideshowkit.prototype.getCookie = function(key) {

        var cookieDataString = window.document.cookie.replace(
            new RegExp('(?:(?:^|.*;\s*)' + key + '\s*\=\s*([^;]*).*$)|^.*$'), "$1"
        );

        return cookieDataString ? JSON.parse(cookieDataString) : {};
    };

    /**
     * Save cookie as JSON
     *
     * @param {string} key
     * @param {Object} value
     *
     * @return {PkgSlideshowkit}
     */
    PkgSlideshowkit.prototype.setCookie = function(key, value) {

        var valueStringified = JSON.stringify(value);
        var cookieString = key + '=' + valueStringified;
        var expiresDate;

        if (this.options.cookie.path) {
            cookieString += '; path=' + this.options.cookie.path;
        }

        if (this.options.cookie.domain) {
            cookieString += '; domain=' + this.options.cookie.domain;
        }

        /*
        // Note: keep it as session
        if (this.options.cookie.maxAge) {
            expiresDate = new Date();
            expiresDate.setSeconds(expiresDate.getSeconds() + this.options.cookie.maxAge);

            cookieString += '; expires=' + expiresDate.toUTCString();
        }
        */

        window.document.cookie = cookieString;

        return this;
    };

    return PkgSlideshowkit;

}(jQuery));
